import type { ReactNode } from "react";
import { Plus } from "lucide-react";
import { Spinner } from "../Spinner";

/** The screen's title and its one primary action (New post, New product, New category). */
export function ListHead({ title, action, status }: { title: string; status?: ReactNode; action?: { label: string; onClick: () => void; disabled?: boolean; busy?: boolean } }) {
  return <div className="bw-area-title">
    <h1>{title}{status}</h1>
    {action && <button type="button" className="bw-btn bw-btn--primary bw-btn--action" disabled={action.disabled || action.busy} aria-busy={action.busy} onClick={action.onClick}>{action.busy ? <Spinner /> : <Plus size={16} aria-hidden="true" />} {action.label}</button>}
  </div>;
}
